import { z } from 'zod';
import { UUIDSchema } from '../ids.js';
export const EmployeeStatus = z.enum(['invited', 'active', 'suspended', 'offboarded']);
export const EmployeeRole = z.enum(['employee', 'manager']);
export const Employee = z.object({
    id: UUIDSchema,
    tenant_id: UUIDSchema,
    email: z.string().email(),
    name: z.string(),
    role: EmployeeRole,
    status: EmployeeStatus,
    unifi_user_id: z.string().nullable(),
    schedule_id: UUIDSchema.nullable(),
    created_at: z.string().datetime(),
    updated_at: z.string().datetime(),
});
export const CreateEmployeeBody = z.object({
    email: z.string().email().max(254),
    name: z.string().min(1).max(120),
    role: EmployeeRole.default('employee'),
    schedule_id: UUIDSchema,
});
export const UpdateEmployeeBody = z.object({
    name: z.string().min(1).max(120).optional(),
    role: EmployeeRole.optional(),
    status: EmployeeStatus.optional(),
    schedule_id: UUIDSchema.nullable().optional(),
});
export const ListEmployeesQuery = z.object({
    status: EmployeeStatus.optional(),
    q: z.string().max(120).optional(),
    cursor: z.string().max(2048).optional(),
    limit: z.coerce.number().int().min(1).max(200).default(50),
});
//# sourceMappingURL=employee.js.map